import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import { isValidJiraIssueKey } from '../../../utils/jira-create-with-rovo-preview-card';
import type { GicModalEntryPointParams, GicModalProps, GicModalQueries } from '../index';

import entrypointGicModalParentIssueQuery from './__generated__/entrypointGicModalParentIssueQuery.graphql';

export const gicModalEntryPoint: EntryPoint<
	EntryPointComponent<
		GicModalQueries,
		Record<string, never>,
		GicModalProps & { onClose: () => void },
		Record<string, never>
	>,
	GicModalEntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_conversation-assistant-preview-card_gic-modal-entrypoint" */ '../index'
			),
		{
			moduleId: 'conversation-assistant-preview-card_gic-modal-entrypoint',
		},
	),
	getPreloadProps: ({ cloudId, parentIssue }: GicModalEntryPointParams) => ({
		queries: {
			entrypointGicModalParentIssueQuery: {
				options: { fetchPolicy: 'network-only' as const },
				parameters: entrypointGicModalParentIssueQuery,
				variables: {
					cloudId,
					parentIssueKey: parentIssue ?? '',
					shouldFetchParentIssue: !!parentIssue && isValidJiraIssueKey(parentIssue),
				},
			},
		},
	}),
});
